/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InputAdminChatChannel
 */
export interface InputAdminChatChannel {
    /**
     * 
     * @type {string}
     * @memberof InputAdminChatChannel
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof InputAdminChatChannel
     */
    type: string;
    /**
     * 
     * @type {number}
     * @memberof InputAdminChatChannel
     */
    zone?: number;
}

/**
 * Check if a given object implements the InputAdminChatChannel interface.
 */
export function instanceOfInputAdminChatChannel(value: object): boolean {
    if (!('name' in value)) return false;
    if (!('type' in value)) return false;
    return true;
}

export function InputAdminChatChannelFromJSON(json: any): InputAdminChatChannel {
    return InputAdminChatChannelFromJSONTyped(json, false);
}

export function InputAdminChatChannelFromJSONTyped(json: any, ignoreDiscriminator: boolean): InputAdminChatChannel {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'type': json['type'],
        'zone': json['zone'] == null ? undefined : json['zone'],
    };
}

export function InputAdminChatChannelToJSON(value?: InputAdminChatChannel | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'name': value['name'],
        'type': value['type'],
        'zone': value['zone'],
    };
}

